import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Terms & Conditions | Skyline Cabs</title>
        <meta name="description" content="Read the Terms and Conditions of Skyline Cabs services, including booking policies, payment, cancellations, and more." />
      </Helmet>
      <section
    className="bg-cover position-relative"
    style={{
      background: 'url(/img/bg-title.jpg) no-repeat',
    }}
    data-overlay="5"
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-xl-7 col-lg-9 col-md-12">
          <div className="fpc-capstion text-center my-4">
            <div className="fpc-captions">
              <h1 className="xl-heading text-light">Terms & Conditions              </h1>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All bookings with Skyline Cabs are subject to availability and will be confirmed upon receipt of full payment and issuance of a booking reference number.</p>

                <p><b className="highlight">2. Payment:</b> Payments must be completed at the time of booking via our secure online portal or other authorized payment methods.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Changes or cancellations to bookings must comply with our cancellation policy, which may include applicable fees based on the timing of the request.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers must carry valid identification and booking confirmations. Skyline Cabs reserves the right to deny service without proper documentation.</p>

                <p><b className="highlight">5. Baggage Policy:</b> Passengers may bring a limited amount of baggage per booking. Excess baggage may incur additional charges, and must be confirmed during booking.</p>

                <p><b className="highlight">6. Travel Insurance:</b> While we ensure a safe journey, we recommend obtaining travel insurance for unforeseen circumstances and events during travel.</p>

                <p><b className="highlight">7. Safety Regulations:</b> All passengers must adhere to safety guidelines and driver instructions to ensure a secure journey. Failure to comply with safety measures may result in service denial.</p>

                <p><b className="highlight">8. Changes to Itinerary:</b> Skyline Cabs reserves the right to adjust routes or schedules due to weather, traffic, or other unforeseen conditions. Any such changes will be communicated in advance, if possible.</p>

                <p><b className="highlight">9. Refusal of Service:</b> We may refuse service to passengers exhibiting inappropriate behavior, violating terms, or compromising the safety of other passengers or drivers.</p>

                <p><b className="highlight">10. Jurisdiction:</b> These terms are governed by the laws of India, and any disputes will be settled in the jurisdiction of Pune.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Book your cab via our website, mobile app, or customer service helpline for a seamless experience and convenience.</p>
                <p><b className="highlight">Customer Support:</b> Our dedicated customer support team is available 24/7 to address any questions or concerns you may have. We strive to provide timely assistance and resolve any issues promptly.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Cancellation Fees:</b> Refunds may be subject to cancellation charges based on the timing of the request. These fees are outlined in our cancellation policy, which is provided during booking.</p>
                <p><b className="highlight">Refund Process:</b> Refunds will be processed within 7-10 business days through the original payment method. If there are any issues with the refund process, our customer support team will assist you.</p>
                <p><b className="highlight">No-Show Policy:</b> No-shows are not eligible for refunds or rescheduling. In case of cancellation or changes, passengers must notify Skyline Cabs at least 24 hours before the scheduled booking time to avoid charges.</p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions or need clarification about our terms, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+917620911746">+91 7620911746</a></li>
              <li><b>Email:</b> <a href="mailto:booking@skylinecabs.com">booking@skylinecabs.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
